import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode } from './common-interfaces';

import { OperationAssignmentsService } from './operation-assignments.service';
import { UtilsService } from './utils.service';



@Injectable({ providedIn: 'root' })
export class FootprintEdi_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
    private operationAssignmentsService: OperationAssignmentsService,
  ) {
  }

  public FootprintEdi: FootprintEdi_OperationService = this;


  isAssigned(operationName: string, mode: EAssignmentMode): Promise<boolean> {
    var referenceName = 'FootprintEdi';    
    return Promise.resolve(this.operationAssignmentsService.isAssigned(referenceName, operationName, mode));
  }
}
